export default __webpack_public_path__ + "static/24934223-snap-802ca4f97cae416035a1fea734be2ab0.jpg";